import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { Meeting, MeetingStatus } from "../../types";
import { getCalendarMeetingTypeLabel } from "./calendar-status-utils";
import JoinMeetingButton from "../meeting-management/common/join-meeting-button";

interface MeetingStatusTagProps {
    canJoin: boolean;
    status: MeetingStatus;
    message?: string;
    meeting: Meeting;
}

const MeetingStatusTag: React.FC<MeetingStatusTagProps> = ({
    canJoin,
    status,
    message,
    meeting,
}) => {
    const theme = useTheme();

    if (canJoin) {
        return (
            <Stack spacing={1} alignItems="center">
                <JoinMeetingButton
                    meetingId={meeting.meetingId}
                    fullWidth={false}
                />
                {message && (
                    <Typography variant="caption" color="textSecondary">
                        {message}
                    </Typography>
                )}
            </Stack>
        );
    }

    const paletteEntry = theme.palette.meetingStatus[status];

    return (
        <Box
            sx={{
                display: "inline-flex",
                alignItems: "center",
                borderRadius: 1,
                px: 1.25,
                py: 1,
                backgroundColor: paletteEntry?.main,
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    color: "#fff",
                    fontWeight: 600,
                    lineHeight: 1,
                }}
            >
                {getCalendarMeetingTypeLabel(status)}
            </Typography>
        </Box>
    );
};

export default MeetingStatusTag;